import { required } from 'ra-core';
import { TextInput } from '../../components/admin/text-input';
import { MoonstarCreate } from '../Moonstar/MoonstarCreate';
import { MoonstarCreateForm } from '../Moonstar/MoonstarCreateForm';
import { SimpleStack } from '../Moonstar/SimpleStack';
import { RolePermissionsEditor } from './RolePermissionsEditor';

export const RoleCreate = () => (
  <MoonstarCreate redirect="list">
    <MoonstarCreateForm className="max-w-none">
      <SimpleStack>
        <TextInput source="name" validate={required()} />
      </SimpleStack>
      <SimpleStack className="sm:w-full">
        <RolePermissionsEditor />
      </SimpleStack>
    </MoonstarCreateForm>
  </MoonstarCreate>
);
